export default {
            Auth: {
                region: 'us-east-1',
                userPoolId: 'us-east-1_VsCHnEtpa',
                userPoolWebClientId: '4ft1femjk0e4ldduia2a9ar73v',
                oauth: {
                    domain: 'smart-app-broker-console-us1-prod.auth.us-east-1.amazoncognito.com',
                    scope: ['email', 'profile', 'openid'],
                    redirectSignIn: 'https://smart-app-broker.prod.bd-mms.com/console',
                    redirectSignOut: 'https://smart-app-broker.prod.bd-mms.com/console',
                    responseType: 'code',
                    options: {
                        AdvancedSecurityDataCollectionFlag: false
                    }
                }
            }
        }